import { Injectable }   from '@angular/core';
import { Store }        from '@ngrx/store';
import { UserSettings } from '~domain/types';
import {
  fetchAccountsWithWarningBadgeCount,
  fetchAccountUser,
  fetchClientBadgeCount,
  fetchDocumentBadgeCount,
  fetchNewBudgetAppEnabled,
  fetchNotificationBadgeCount,
  fetchPaymentBadgeCount,
  fetchUnlinkedAccountsBadgeCount,
  fetchUserSettings,
  logout,
  setUserSettings,
}                       from '../state/app.actions';
import {
  selectAccountsWithWarningBadgeCount,
  selectAccountUser,
  selectClientBadgeCount,
  selectDocumentBadgeCount,
  selectNotificationBadgeCount,
  selectOffice,
  selectPaymentBadgeCount,
  selectUnlinkedAccountsBadgeCount,
}                       from '../state/app.selectors';

@Injectable({
  providedIn: 'root',
})
export class MainService {
  accountUser$ = this.store.select(selectAccountUser);
  office$ = this.store.select(selectOffice);
  clientBadgeCount$ = this.store.select(selectClientBadgeCount);
  notificationBadgeCount$ = this.store.select(selectNotificationBadgeCount);
  unlinkedAccountBadgeCount$ = this.store.select(selectUnlinkedAccountsBadgeCount);
  accountsWithWarningBadgeCount$ = this.store.select(selectAccountsWithWarningBadgeCount);
  paymentBadgeCount$ = this.store.select(selectPaymentBadgeCount);
  documentBadgeCount$ = this.store.select(selectDocumentBadgeCount);

  constructor(
    private readonly store: Store,
  ) {
  }

  fetchAccountUser(): void {
    this.store.dispatch(fetchAccountUser());
  }

  fetchUserSettings(): void {
    this.store.dispatch(fetchUserSettings());
  }

  fetchNewBudgetAppEnabled(): void {
    this.store.dispatch(fetchNewBudgetAppEnabled());
  }

  setUserSettings(userSettings: UserSettings) {
    this.store.dispatch(setUserSettings({ userSettings }));
  }

  fetchClientBadgeCount(): void {
    this.store.dispatch(fetchClientBadgeCount());
  }

  fetchNotificationBadgeCount(): void {
    this.store.dispatch(fetchNotificationBadgeCount());
  }

  fetchPaymentBadgeCount(): void {
    this.store.dispatch(fetchPaymentBadgeCount());
  }

  fetchUnlinkedAccountsBadgeCount(): void {
    this.store.dispatch(fetchUnlinkedAccountsBadgeCount());
  }

  fetchAccountsWithWarningBadgeCount(): void {
    this.store.dispatch(fetchAccountsWithWarningBadgeCount());
  }

  fetchDocumentBadgeCount(): void {
    this.store.dispatch(fetchDocumentBadgeCount());
  }

  logout() {
    this.store.dispatch(logout());
  }
}
